var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-navigation',{attrs:{"page-size":_vm.PAGE_SIZE,"total-count":_vm.usersTotalCount},on:{"fetchData":_vm.fetchData}},[_c('users-list',{attrs:{"users":_vm.users}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }